import React from "react";

import {
  Devices,
  Flag,
  Alarm,
  Person,
  HeadsetMic,
  Settings,
  Security,
  Lock,
  PhoneIphone,
  Email,
  Notifications,
  ArrowForwardIos,
  FitnessCenter,
} from "@mui/icons-material";
import "./Settings.css";


import { Box, Typography } from "@mui/material"; // Material UI components for styling
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos"; // Icon for back navigation
import { useNavigate, useLocation } from "react-router-dom"; // React Router hooks for navigation and location

const settingsItems = [
  { text: "Google Fit", icon: <FitnessCenter />, route: "/apps-devices" },
  { text: "Goals & Habits", icon: <Flag />, route: "/goals_and_habits" },
  { text: "Edit Profile", icon: <Person />, route: "/fsn37" },
  { text: "Support", icon: <HeadsetMic />, route: "/fsn170" },
  { text: "Preferences", icon: <Settings />, route: "/fsn40" },
  { text: "Privacy", icon: <Security />, route: "/fsn41" },
];

const Fsn44ProfileSetting = () => {

  const location = useLocation();
  const navigate = useNavigate();
  // Extract and log all query parameters
  const queryParams = new URLSearchParams(location.search);

  // Convert query parameters to an object (optional)
  const paramsObject = {};
  queryParams.forEach((value, key) => {
    paramsObject[key] = value;
  });
  // Function to handle the back button press
  const handleBackButtonPress = () => {
    if (location.pathname === "/settings") {
      // Logic for handling back only on "/doctor-consultation"
      if (window.Android) {
        // If on Android, call the Android bridge method
        window.Android.onBackPressed();
      } else {
        navigate(-1); // Navigate back in history
      }
    }
  };

  const navigateScreen = (item) => {



    // Extract and log all query parameters
    const queryParams = new URLSearchParams(location.search);

    // Convert query parameters to an object (optional)
    const paramsObject = {};
    queryParams.forEach((value, key) => {
      paramsObject[key] = value;
    });

    navigate(item+`?${queryParams}`);



  };
  return (
    <> <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "10px 16px",
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd",
      }}
    >
      <ArrowBackIosIcon
        sx={{ cursor: "pointer" }}
        onClick={() => handleBackButtonPress()} // Handle back navigation
      />
      <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
        Settings
      </Typography>
    </Box>
      <div className="settings-container">
        {/* Title Bar with Back Button */}
        {/* Header section with back button and title */}

        <ul className="settings-list" >
          {settingsItems.map((item) => (
            <li
              key={item.text}
              className="settings-list-item"
              onClick={() => navigateScreen(item.route)}
            >
              <div className="settings-list-icon">{item.icon}</div>
              <div className="settings-list-text">{item.text}</div>
              <ArrowForwardIos className="settings-arrow" />
            </li>
          ))}
        </ul>
      </div>
    </>

  );
};

export default Fsn44ProfileSetting;